import { createSelector } from "reselect"
import { get, chain, last, map } from "lodash"
import { getOriginalForecast, getBenchmarkReturn } from "modules/optimization/selectors/data"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}
export const getScannerChartPoints = state => get(state, "modules.optimizationScanner.optimizationScannerData", EMPTY_ARRAY)
export const getRiskTarget = (state, props) => get(props, "riskTarget", EMPTY_OBJECT)
export const getStatus = state => get(state, "modules.optimizationScanner.status")

const adjustData = createSelector(
  [getScannerChartPoints, getBenchmarkReturn],
  (scannerPoints, benchmarkReturn) =>
    map(scannerPoints, ([predictedTotalRisk, expectedReturn]) => [predictedTotalRisk, expectedReturn - benchmarkReturn]),
)

export const getData = createSelector(
  [adjustData],
  (scannerChartPoints) => chain(scannerChartPoints)
    .take(25)
    .orderBy(point => point[0])
    .map(([predictedTotalRisk, expectedReturn]) => ({
      x: predictedTotalRisk,
      y: expectedReturn,
    }))
    .value(),
)

export const getBestPointData = createSelector(
  [adjustData],
  (scannerChartData) => {
    if (scannerChartData && scannerChartData.length > 0) {
      const [predictedTotalRisk, expectedReturn] = last(scannerChartData)
      return { predictedTotalRisk, expectedReturn }
    }

    return null
  },
)

export const getRiskTargetPoint = createSelector(
  [getRiskTarget],
  ({ predictedTotalRisk }) => {
    if (predictedTotalRisk) {
      return {
        x: predictedTotalRisk,
      }
    }
    return null
  },
)

export const getChartDots = createSelector(
  [getOriginalForecast, getBestPointData],
  (forecast, point) => {
    const dots = []

    if (forecast) {
      dots.push({
        x: forecast.total * 100,
        y: forecast.returnPerc,
        color: "#0076bf",
        className: "original-point",
        label: "Original portfolio",
        noTitle: true,
      })
    }

    if (point) {
      dots.push({
        x: point.predictedTotalRisk,
        y: point.expectedReturn,
        color: "#00abe8",
        label: "Best risk-adjusted return",
      })
    }

    return dots
  },
)
